export default "__VITE_ASSET__DDfXeZQA__"